(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown-announcement"] && !Shopify.designMode) return;
  try {
    
  class CountdownAnnouncement extends HTMLElement {
    connectedCallback() {
      if (this.intervalId) return;

      this.daysElement = this.querySelector('[data-countdown-days]');
      this.hoursElement = this.querySelector('[data-countdown-hours]');
      this.minutesElement = this.querySelector('[data-countdown-minutes]');
      this.secondsElement = this.querySelector('[data-countdown-seconds]');
      this.timerElement = this.querySelector('[data-countdown-timer]');
      this.headingElement = this.querySelector('[data-countdown-heading]');
      this.expiredMessageElement = this.querySelector('[data-countdown-expired-message]');
      this.buttonElement = this.querySelector('[data-countdown-button]');
      this.statusElement = this.querySelector('[data-countdown-status]');

      if (!this.hoursElement || !this.minutesElement || !this.secondsElement) return;

      this.endTime = this.getEndTime();
      this.intervalId = window.setInterval(() => this.update(), 1000);
      this.update();
    }

    disconnectedCallback() {
      if (this.intervalId) window.clearInterval(this.intervalId);
      this.intervalId = undefined;
    }

    get storage() {
      return this.dataset.persistence === 'session' ? window.sessionStorage : window.localStorage;
    }

    get storageKey() {
      return `rocketz-countdown-announcement-${this.dataset.sectionId}`;
    }

    getEndTime() {
      if (this.dataset.mode === 'fixed') {
        const fixedTime = new Date(this.dataset.endDate || '').getTime();
        return Number.isFinite(fixedTime) ? fixedTime : Date.now();
      }

      const duration = Math.max(1, Number(this.dataset.duration) || 3600) * 1000;

      try {
        const saved = JSON.parse(this.storage.getItem(this.storageKey) || 'null');
        if (saved?.duration === duration && Number.isFinite(saved?.endTime)) return saved.endTime;

        const endTime = Date.now() + duration;
        this.storage.setItem(this.storageKey, JSON.stringify({ duration, endTime }));
        return endTime;
      } catch (_error) {
        return Date.now() + duration;
      }
    }

    restart() {
      const duration = Math.max(1, Number(this.dataset.duration) || 3600) * 1000;
      this.endTime = Date.now() + duration;

      try {
        this.storage.setItem(this.storageKey, JSON.stringify({ duration, endTime: this.endTime }));
      } catch (_error) {
        return;
      }
    }

    update() {
      let remaining = Math.max(0, this.endTime - Date.now());

      if (remaining === 0 && this.dataset.expiredBehavior === 'restart' && this.dataset.mode !== 'fixed') {
        this.restart();
        remaining = Math.max(0, this.endTime - Date.now());
      }

      const days = Math.floor(remaining / 86400000);
      const hours = this.daysElement
        ? Math.floor((remaining / 3600000) % 24)
        : Math.floor(remaining / 3600000);
      const minutes = Math.floor((remaining / 60000) % 60);
      const seconds = Math.floor((remaining / 1000) % 60);
      const pad = (value) => String(value).padStart(2, '0');

      if (this.daysElement) this.daysElement.textContent = pad(days);
      this.hoursElement.textContent = pad(hours);
      this.minutesElement.textContent = pad(minutes);
      this.secondsElement.textContent = pad(seconds);

      const urgentThreshold = Math.max(0, Number(this.dataset.urgentMinutes) || 0) * 60000;
      this.querySelectorAll('.countdown-announcement__value').forEach((element) => {
        element.classList.toggle('is-urgent', remaining > 0 && urgentThreshold > 0 && remaining <= urgentThreshold);
      });

      if (remaining > 0) return;

      window.clearInterval(this.intervalId);
      this.intervalId = undefined;

      if (this.dataset.expiredBehavior === 'hide') {
        this.hidden = true;
        return;
      }

      this.timerElement.hidden = true;
      if (this.headingElement) this.headingElement.hidden = true;
      if (this.buttonElement) this.buttonElement.hidden = true;
      if (this.expiredMessageElement) this.expiredMessageElement.hidden = false;
      if (this.statusElement && this.expiredMessageElement) {
        this.statusElement.textContent = this.expiredMessageElement.textContent?.trim() || '';
      }
    }
  }

  if (!customElements.get('countdown-announcement')) {
    customElements.define('countdown-announcement', CountdownAnnouncement);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagramz"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('instagramz-feed')) {
    customElements.define('instagramz-feed', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.feed = this.querySelector('[data-instagramz-feed]');
        this.posts = Array.from(this.querySelectorAll('[data-instagramz-post]'));
        this.modal = this.querySelector('[data-instagramz-modal]');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.autoplayDelay = Math.max(Number(this.dataset.autoplayDelay || 5000), 2000);
        this.visible = true;
        this.interacting = false;
        this.ratios = new Map();
        if (!this.feed || !this.posts.length) return;

        this.feed.addEventListener('scroll', () => this.queueUpdate(), { passive:true });
        this.feed.addEventListener('keydown', (event) => {
          if (this.dataset.mobileLayout !== 'slider') return;
          if (event.key === 'ArrowLeft') { event.preventDefault(); this.goTo(this.currentIndex() - 1); }
          if (event.key === 'ArrowRight') { event.preventDefault(); this.goTo(this.currentIndex() + 1); }
        });
        this.feed.addEventListener('pointerenter', () => this.pause());
        this.feed.addEventListener('pointerleave', () => this.resume());
        this.feed.addEventListener('touchstart', () => this.pause(), { passive:true });
        this.feed.addEventListener('touchend', () => this.resume(), { passive:true });

        this.querySelectorAll('[data-instagramz-sound]').forEach((button) => {
          button.dataset.muted = 'true';
          button.addEventListener('click', (event) => { event.stopPropagation(); this.toggleSound(button); });
        });
        this.querySelectorAll('[data-instagramz-open]').forEach((button) => button.addEventListener('click', () => this.openModal(button)));
        this.querySelectorAll('[data-instagramz-close]').forEach((button) => button.addEventListener('click', () => this.closeModal()));
        document.addEventListener('keydown', (event) => { if (event.key === 'Escape') this.closeModal(); });
        document.addEventListener('visibilitychange', () => { this.syncVideos(); this.schedule(); });

        this.observePosts();
        this.observeSection();
        this.update();
        this.schedule();
      }

      disconnectedCallback() {
        window.clearTimeout(this.timer);
        window.cancelAnimationFrame(this.frame);
        this.postObserver?.disconnect();
        this.sectionObserver?.disconnect();
        this.querySelectorAll('video').forEach((video) => video.pause());
      }

      currentIndex() {
        const center = this.feed.scrollLeft + this.feed.clientWidth / 2;
        let index = 0;
        let distance = Infinity;
        this.posts.forEach((post, postIndex) => {
          const postCenter = post.offsetLeft + post.offsetWidth / 2;
          const currentDistance = Math.abs(postCenter - center);
          if (currentDistance < distance) { distance = currentDistance; index = postIndex; }
        });
        return index;
      }

      goTo(index) {
        if (this.dataset.mobileLayout !== 'slider' || window.innerWidth > 749) return;
        const target = (index + this.posts.length) % this.posts.length;
        this.feed.scrollTo({ left:this.posts[target].offsetLeft - (this.feed.clientWidth - this.posts[target].offsetWidth) / 2, behavior:this.reducedMotion.matches ? 'auto' : 'smooth' });
        this.schedule();
      }

      queueUpdate() { window.cancelAnimationFrame(this.frame); this.frame = requestAnimationFrame(() => this.update()); }
      update() {
        const progress = this.querySelector('[data-instagramz-progress]');
        if (progress) progress.style.transform = `scaleX(${(this.currentIndex() + 1) / this.posts.length})`;
        this.syncVideos();
      }

      pause() { this.interacting = true; window.clearTimeout(this.timer); }
      resume() { this.interacting = false; this.schedule(); }
      schedule() {
        window.clearTimeout(this.timer);
        if (this.dataset.autoplay !== 'true' || this.dataset.mobileLayout !== 'slider' || window.innerWidth > 749 || this.interacting || !this.visible || document.hidden || this.reducedMotion.matches || this.posts.length < 2) return;
        this.timer = window.setTimeout(() => this.goTo(this.currentIndex() + 1), this.autoplayDelay);
      }

      observePosts() {
        if (!('IntersectionObserver' in window)) return;
        this.postObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => this.ratios.set(entry.target, entry.intersectionRatio));
          this.syncVideos();
        }, { threshold:[0,.25,.5,.75,1] });
        this.posts.forEach((post) => this.postObserver.observe(post));
      }

      observeSection() {
        if (!('IntersectionObserver' in window)) return;
        this.sectionObserver = new IntersectionObserver((entries) => {
          this.visible = entries[0]?.isIntersecting ?? false;
          this.syncVideos();
          this.schedule();
        }, { threshold:.1 });
        this.sectionObserver.observe(this);
      }

      syncVideos() {
        let activePost = null;
        let bestRatio = 0;
        this.posts.forEach((post) => {
          const ratio = this.ratios.get(post) || 0;
          if (ratio > bestRatio) { activePost = post; bestRatio = ratio; }
        });
        this.posts.forEach((post) => {
          const video = post.querySelector('video');
          if (!video) return;
          const shouldPlay = post === activePost && bestRatio >= .5 && this.visible && !document.hidden && this.dataset.videoAutoplay === 'true';
          if (shouldPlay) video.play().then(() => { post.dataset.playing = 'true'; }).catch(() => {});
          else { video.pause(); post.dataset.playing = 'false'; }
        });
      }

      toggleSound(button) {
        const video = button.closest('[data-instagramz-post]')?.querySelector('video');
        if (!video) return;
        video.muted = !video.muted;
        button.dataset.muted = String(video.muted);
        button.ariaLabel = video.muted ? button.dataset.soundOnLabel : button.dataset.soundOffLabel;
        if (video.paused) video.play().catch(() => {});
      }

      openModal(button) {
        if (!this.modal) return;
        const post = button.closest('[data-instagramz-post]');
        const source = post?.querySelector('video') || post?.querySelector('.instagramz__image');
        const media = this.modal.querySelector('[data-instagramz-modal-media]');
        if (!post || !source || !media) return;
        this.lastFocused = button;
        media.replaceChildren(source.cloneNode(true));
        const modalVideo = media.querySelector('video');
        if (modalVideo) { modalVideo.controls = true; modalVideo.muted = false; modalVideo.play().catch(() => {}); }
        const user = post.querySelector('.instagramz__post-user strong')?.textContent || '';
        const caption = post.querySelector('[data-instagramz-caption]');
        this.modal.querySelector('[data-instagramz-modal-user]').textContent = user;
        this.modal.querySelector('[data-instagramz-modal-caption]').innerHTML = caption?.innerHTML || '';
        this.previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.modal.hidden = false;
        this.modal.querySelector('.instagramz__modal-close')?.focus({ preventScroll:true });
      }

      closeModal() {
        if (!this.modal || this.modal.hidden) return;
        this.modal.querySelector('video')?.pause();
        this.modal.querySelector('[data-instagramz-modal-media]')?.replaceChildren();
        this.modal.hidden = true;
        document.documentElement.style.overflow = this.previousOverflow || '';
        this.lastFocused?.focus?.({ preventScroll:true });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugcz"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ugcz-carousel')) {
    customElements.define(
      'ugcz-carousel',
      class extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.track = this.querySelector('[data-ugcz-track]');
          this.cards = Array.from(this.querySelectorAll('[data-ugcz-card]'));
          if (!this.track || !this.cards.length) return;

          this.currentOutput = this.querySelector('[data-ugcz-current]');
          this.totalOutput = this.querySelector('[data-ugcz-total]');
          this.progress = this.querySelector('[data-ugcz-progress]');
          this.status = this.querySelector('[data-ugcz-status]');
          this.previousButton = this.querySelector('[data-ugcz-previous]');
          this.nextButton = this.querySelector('[data-ugcz-next]');
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.autoplayDelay = Math.max(Number(this.dataset.autoplayDelay || 5000), 2000);
          this.pauseOnInteraction = this.dataset.autoplayBehavior === 'pause';
          this.isVisible = true;
          this.isInteracting = false;

          this.previousButton?.addEventListener('click', () => this.goTo(this.currentIndex() - 1));
          this.nextButton?.addEventListener('click', () => this.goTo(this.currentIndex() + 1));
          this.track.addEventListener('scroll', () => this.queueUpdate(), { passive: true });
          this.track.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowLeft') {
              event.preventDefault();
              this.goTo(this.currentIndex() - 1);
            }
            if (event.key === 'ArrowRight') {
              event.preventDefault();
              this.goTo(this.currentIndex() + 1);
            }
          });

          if (this.pauseOnInteraction) {
            this.addEventListener('pointerenter', () => this.pauseAutoplay());
            this.addEventListener('pointerleave', () => this.resumeAutoplay());
            this.addEventListener('focusin', () => this.pauseAutoplay());
            this.addEventListener('focusout', () => this.resumeAutoplay());
            this.track.addEventListener('touchstart', () => this.pauseAutoplay(), { passive: true });
            this.track.addEventListener('touchend', () => this.resumeAutoplay(), { passive: true });
          }

          this.querySelectorAll('[data-ugcz-play]').forEach((button) => {
            button.addEventListener('click', () => this.togglePlayback(button));
          });
          this.querySelectorAll('[data-ugcz-sound]').forEach((button) => {
            button.dataset.muted = 'true';
            button.addEventListener('click', () => this.toggleSound(button));
          });

          this.observeSection();
          if ('ResizeObserver' in window) {
            this.resizeObserver = new ResizeObserver(() => this.update());
            this.resizeObserver.observe(this.track);
          }
          document.addEventListener('visibilitychange', () => {
            this.scheduleAutoplay();
            this.syncVideos(this.currentIndex());
          });
          this.update();
          this.scheduleAutoplay();
        }

        disconnectedCallback() {
          window.clearTimeout(this.autoplayTimer);
          window.cancelAnimationFrame(this.updateFrame);
          this.sectionObserver?.disconnect();
          this.resizeObserver?.disconnect();
          this.querySelectorAll('video').forEach((video) => video.pause());
        }

        currentIndex() {
          const center = this.track.scrollLeft + this.track.clientWidth / 2;
          let closestIndex = 0;
          let closestDistance = Infinity;
          this.cards.forEach((card, index) => {
            const cardCenter = card.offsetLeft + card.offsetWidth / 2;
            const distance = Math.abs(cardCenter - center);
            if (distance < closestDistance) {
              closestIndex = index;
              closestDistance = distance;
            }
          });
          return closestIndex;
        }

        goTo(index) {
          const normalizedIndex = (index + this.cards.length) % this.cards.length;
          this.track.scrollTo({
            left: this.cards[normalizedIndex].offsetLeft,
            behavior: this.reducedMotion.matches ? 'auto' : 'smooth',
          });
          this.scheduleAutoplay();
        }

        queueUpdate() {
          window.cancelAnimationFrame(this.updateFrame);
          this.updateFrame = window.requestAnimationFrame(() => this.update());
        }

        update() {
          const index = this.currentIndex();
          const hasOverflow = this.track.scrollWidth > this.track.clientWidth + 2;
          const current = String(index + 1).padStart(2, '0');
          const total = String(this.cards.length).padStart(2, '0');
          if (this.currentOutput) this.currentOutput.textContent = current;
          if (this.totalOutput) this.totalOutput.textContent = total;
          if (this.progress) this.progress.style.transform = `scaleX(${(index + 1) / this.cards.length})`;
          if (this.status) this.status.textContent = `${index + 1} / ${this.cards.length}`;
          if (this.previousButton) this.previousButton.disabled = !hasOverflow;
          if (this.nextButton) this.nextButton.disabled = !hasOverflow;
          const navigation = this.querySelector('[data-ugcz-navigation]');
          const footer = this.querySelector('[data-ugcz-footer]');
          if (navigation) navigation.hidden = !hasOverflow;
          if (footer) footer.hidden = !hasOverflow;
          this.syncVideos(index);
        }

        pauseAutoplay() {
          this.isInteracting = true;
          window.clearTimeout(this.autoplayTimer);
        }

        resumeAutoplay() {
          this.isInteracting = false;
          this.scheduleAutoplay();
        }

        scheduleAutoplay() {
          window.clearTimeout(this.autoplayTimer);
          if (
            this.dataset.autoplay !== 'true' ||
            this.reducedMotion.matches ||
            document.hidden ||
            !this.isVisible ||
            this.isInteracting ||
            this.cards.length < 2
          ) return;
          this.autoplayTimer = window.setTimeout(() => this.goTo(this.currentIndex() + 1), this.autoplayDelay);
        }

        observeSection() {
          if (!('IntersectionObserver' in window)) return;
          this.sectionObserver = new IntersectionObserver((entries) => {
            this.isVisible = entries[0]?.isIntersecting ?? false;
            this.scheduleAutoplay();
            this.syncVideos(this.currentIndex());
          }, { threshold: .12 });
          this.sectionObserver.observe(this);
        }

        syncVideos(activeIndex) {
          this.cards.forEach((card, index) => {
            const video = card.querySelector('video');
            const playButton = card.querySelector('[data-ugcz-play]');
            if (!video) return;
            const shouldPlay =
              index === activeIndex &&
              this.isVisible &&
              !document.hidden &&
              this.dataset.videoAutoplay === 'true';
            if (shouldPlay) {
              video.play().then(() => {
                card.dataset.playing = 'true';
                if (playButton) {
                  playButton.dataset.playing = 'true';
                  playButton.ariaLabel = playButton.dataset.pauseLabel;
                }
              }).catch(() => {});
            } else {
              video.pause();
              card.dataset.playing = 'false';
              if (playButton) {
                playButton.dataset.playing = 'false';
                playButton.ariaLabel = playButton.dataset.playLabel;
              }
            }
          });
        }

        togglePlayback(button) {
          const card = button.closest('[data-ugcz-card]');
          const video = card?.querySelector('video');
          if (!video) return;
          if (video.paused) {
            this.cards.forEach((otherCard) => {
              if (otherCard === card) return;
              otherCard.querySelector('video')?.pause();
              otherCard.dataset.playing = 'false';
            });
            video.play().then(() => {
              card.dataset.playing = 'true';
              button.dataset.playing = 'true';
              button.ariaLabel = button.dataset.pauseLabel;
            }).catch(() => {});
          } else {
            video.pause();
            card.dataset.playing = 'false';
            button.dataset.playing = 'false';
            button.ariaLabel = button.dataset.playLabel;
          }
        }

        toggleSound(button) {
          const card = button.closest('[data-ugcz-card]');
          const video = card?.querySelector('video');
          if (!video) return;
          video.muted = !video.muted;
          button.dataset.muted = String(video.muted);
          button.ariaLabel = video.muted ? button.dataset.soundOnLabel : button.dataset.soundOffLabel;
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();
})();
